$(function() {

  $(window).on('load resize', function() {
    var windowWidth = $(window).innerWidth();
    if($('.home-ServiceBlock').length) {
      if(windowWidth < 1024) {
        $('.home-ServiceBlock_Body').matchHeight();
      }
    }
  });

}());
